import { useTranslation } from "react-i18next";
import { Link } from "@inertiajs/react";
import { SectionTitle } from "@sprout/typography.tsx";
import ArrowRightIcon from "@sprout/icons/arrow_right.tsx";
import { useContext } from "react";
import { SubscriptionCountContext } from "@components/job_alerts/header.tsx";

export const Header = () => {
  const { t } = useTranslation("jobAlerts");
  const count = useContext(SubscriptionCountContext);
  const title = count > 0 ? `${t("yourJobAlerts")} (${count})` : t("yourJobAlerts");

  return (
    <Link href="/subscriptions" className="job-alerts-widget__header">
      <SectionTitle>{title}</SectionTitle>
      <div className="job-alerts-widget__header_icon">
        <ArrowRightIcon />
      </div>
    </Link>
  );
};
